import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: '¿Qué sistemas son compatibles?',
    answer: 'Certy está disponible para Windows 10 y Windows 11. La licencia se asigna al equipo en el que se activa.',
  },
  {
    question: '¿Los certificados salen del equipo?',
    answer: 'No. Certy trabaja con los certificados instalados en Windows. Las claves privadas permanecen en el almacén del sistema.',
  },
  {
    question: '¿Puedo abrir varios portales con certificados distintos?',
    answer: 'Sí. Cada pestaña conserva el certificado elegido al abrirla, incluso al cambiar a otro trámite dentro de Certy.',
  },
  {
    question: '¿Se pueden importar varios certificados?',
    answer: 'Sí. Puedes seleccionar una carpeta con archivos PFX o P12 y probar una contraseña común. Certy indica cuáles se instalaron, cuáles ya existían y cuáles necesitan revisión.',
  },
  {
    question: '¿Cómo funciona la firma de PDF?',
    answer: 'Seleccionas el documento y el certificado, colocas el sello y guardas una copia firmada. En documentos de varias páginas puedes repetir la posición en todas ellas.',
  },
  {
    question: '¿Puedo comprobarlo antes de pagar?',
    answer: 'Sí. Puedes descargar e instalar Certy para comprobar que reconoce los certificados del equipo. La licencia se activa desde la aplicación cuando decidas continuar.',
  },
];

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="border-b border-[#c9d2cc] bg-[#f5f7f5] py-14 md:py-16">
      <div className="mx-auto grid max-w-[1240px] gap-10 px-5 sm:px-8 lg:grid-cols-[0.68fr_1.32fr] lg:px-10">
        <h2 className="max-w-[11ch] text-4xl font-semibold leading-[1] tracking-[-0.045em] text-[#07110d] md:text-5xl">Preguntas frecuentes.</h2>

        <div className="border-t border-[#aebbb2]">
          {faqs.map((faq, index) => {
            const open = openIndex === index;
            return (
              <article key={faq.question} className="border-b border-[#aebbb2]">
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-5 py-5 text-left"
                >
                  <span className="text-base font-semibold text-[#07110d] md:text-lg">{faq.question}</span>
                  <ChevronDown className={`h-5 w-5 shrink-0 text-[#526158] transition-transform ${open ? 'rotate-180' : ''}`} />
                </button>
                {open && <p className="max-w-[65ch] pb-6 pr-10 text-base leading-7 text-[#526158]">{faq.answer}</p>}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
